import { messages } from './AutogenerateScheduleButton.messages';

export const getAutogenerateScheduleTooltip = (intl, autogenerateDisabledForFreemium, isOnlyOneLocationSelected) => {
  if (autogenerateDisabledForFreemium) return intl.formatMessage(messages.freemiumDisabled);
  if (!isOnlyOneLocationSelected) return intl.formatMessage(messages.chooseOneLocation);
  return null;
};
